/**
 * Given a tree path id like "1/12/123/1234",
 * returns all prefix paths (from depth 2 onward)
 * Used to auto-expand the tree on load.
 *
 * Example:
 * "1/12/123/1234" → ["1/12", "1/12/123", "1/12/123/1234"]
 */
const getExpandedTreePaths = (pathId: string) => {
  const separator = "/";
  const minDepth = 2; // start expanding at 2nd level

  if (!pathId || typeof pathId !== "string") return [];

  // Trim spaces, strip leading/trailing separators, collapse empties
  const parts = pathId.trim().split(separator).filter(Boolean);

  if (parts.length < minDepth) return [];

  // Build prefixes
  const prefixes = [];
  const maxDepth = parts.length;

  for (let depth = minDepth; depth <= maxDepth; depth++) {
    prefixes.push(parts.slice(0, depth).join(separator));
  }

  return prefixes;
};

export default getExpandedTreePaths;
